import React from 'react';
import { IconDeviceDesktopFill } from '@saucelabs/ds-icons';

import Styles from './DevToolsDisabled.styles';

const DevToolsDisabled = () => (
  <div
    className={Styles['text-wrapper']}
    data-qa="developer-drawer-devtools-not-supported"
  >
    <IconDeviceDesktopFill className={Styles['desktop-icon']} />
    <p className={Styles['text-bold']}>
      Dev Tools are not yet available.
    </p>
    <p className={Styles['text-light']}>
      To use Dev Tools, sign into Sauce Labs using Chrome,
      then choose a real Android device to begin your cross browser test session.
    </p>
  </div>
);

export default DevToolsDisabled;
